import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/users/$userId/")({
  component: () => {
    const { userId } = Route.useParams();
    return <Navigate to="/users/$userId/icash-transactions" params={{ userId }} replace />;
  },
});
